// loading用store

import Vue from 'vue';
import storage from '@js/storage';

export const state = () => ({
   loading:false
    
});

export const mutations = {
    updateData(state, n) {
        state.loading = n;
    },
};

export const getters = {
    getData(state) {
        return state;
    },
};

export const actions = {
    updateLoad(store) {
        store.commit('updateData', data);
    },
};